import React from "react";
import {useTranslation} from "react-i18next";

const DescriptionField = ({id, description}) => {
    const {t} = useTranslation();
    if (typeof description === "string") {
        description = t(description, { interpolation: { skipOnVariables: true }});
    }
    return <small id={id} className='form-text text-muted mb-2'>{description}</small>
};

export default DescriptionField;
